import React, { useEffect, useState } from 'react';
import {
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
} from '@material-ui/core';
import Modal from 'components/Modal';
import { useStyles } from '@webapps/styles';
import { cx } from '@emotion/css';

const months = [
  { value: 1, label: 'Janvier' },
  { value: 2, label: 'Février' },
  { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' },
  { value: 8, label: 'Août' },
  { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Décembre' },
];

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);

const stylesFn = ({ spacing, palette }) => ({
  content: {
    // padding: spacing(2),
    // padding: 12,
    backgroundColor: "white",
  },
  formControl: {
    width: '100%',
  },
  periodSection: {
    // marginTop: spacing(2),
  },
  dates: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.25),
  },
  title: {
    paddingBottom: spacing(2),
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: spacing(3),
    gap: spacing(1),
  }
});

const StatementPeriodModalContent = ({ onClose, onConfirm, dateInterval, onCloseDownloadStatementModal }) => {
  const { classes, global } = useStyles(stylesFn);
  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);
  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  const handlePeriodConfirm = () => {
    // Format dates as YYYY-MM-DD
    // First day of start month
    const startDate = `${startYear}-${String(startMonth).padStart(2, '0')}-01`;

    // Last day of end month
    // Get the last day by getting the 0th day of the next month
    // JavaScript months are 0-based, but our month values are 1-based
    const lastDay = new Date(endYear, endMonth, 0).getDate();
    const endDate = `${endYear}-${String(endMonth).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;

    onConfirm(startDate, endDate);
    onClose();
  };

  useEffect(() => {
    if (dateInterval) {

      let startMonth = new Date(dateInterval.startDate).getMonth() + 1;
      let startYear = new Date(dateInterval.startDate).getFullYear();
      let endMonth = new Date(dateInterval.endDate).getMonth() + 1;
      let endYear = new Date(dateInterval.endDate).getFullYear();

      setStartMonth(startMonth);
      setStartYear(startYear);
      setEndMonth(endMonth);
      setEndYear(endYear);
      handlePeriodConfirm();
      if (onCloseDownloadStatementModal) {
        onCloseDownloadStatementModal();
      }
    }
  }, [dateInterval]);

  if (dateInterval) {
    return null;
  }

  return (
    <div className={classes.content}>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.periodSection}>
          <div className={cx(global.title, classes.title)}>
            Période du relevé
          </div>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Date de début
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Mois</InputLabel>
                    <Select
                      value={startMonth}
                      onChange={(e) => setStartMonth(e.target.value)}
                    >
                      {months.map((month) => (
                        <MenuItem key={month.value} value={month.value}>
                          {month.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Année</InputLabel>
                    <Select
                      value={startYear}
                      onChange={(e) => setStartYear(e.target.value)}
                    >
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Date de fin
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Mois</InputLabel>
                    <Select
                      value={endMonth}
                      onChange={(e) => setEndMonth(e.target.value)}
                    >
                      {months.map((month) => (
                        <MenuItem key={month.value} value={month.value}>
                          {month.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Année</InputLabel>
                    <Select
                      value={endYear}
                      onChange={(e) => setEndYear(e.target.value)}
                    >
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <div className={classes.buttonsContainer}>
        <Button onClick={onClose} variant="outlined" color="default">
          Annuler
        </Button>
        <Button onClick={handlePeriodConfirm} variant="contained" color="primary">
          Télécharger
        </Button>
      </div>
    </div>
  );
};

const StatementPeriodModal = ({ open, onClose, onConfirm, dateInterval, onCloseDownloadStatementModal }) => {

  // si y'a dateInterval ça veut dire qu'on lance le telechargement depuis la modal export mulitple et qu'on a choisis qu'un étudiant.
  if (dateInterval) {
    return <StatementPeriodModalContent onClose={onClose} onConfirm={onConfirm} dateInterval={dateInterval} onCloseDownloadStatementModal={onCloseDownloadStatementModal} />
  } else {
    return (
      <Modal
        open={open}
        onCancel={onClose}
        title="Télécharger le relevé"
        maxWidth="md"
        fullWidth
        removeMargin
        styles={
          {
            padding: '20px 24px'
          }
        }
      >
        <StatementPeriodModalContent onClose={onClose} onConfirm={onConfirm} dateInterval={dateInterval} />
      </Modal>
    );
  }
};

export default StatementPeriodModal;
